import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import MsalTokenService from 'Services/MsalTokenService';

const Avatar = () => {
  const [showInfo, setShowInfo] = useState(false);
  const avatarRef = useRef(null);

  const handleAvatarClick = () => {
    setShowInfo(!showInfo);
  };

  const handleClickOutside = (event) => {
    if (avatarRef.current && !avatarRef.current.contains(event.target)) {
      setShowInfo(false);
    }
  };

  useEffect(() => {
    if (showInfo) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showInfo]);

  const currentUser = useSelector((state) => state.currentUser);

  const formatRoles = (roles) => {
    if (!roles || roles.length === 0) {
      return [];
    }
    return roles.filter((value) => value.includes('DS_F2W'));
  };

  const getInitials = () => {
    const nameParts = currentUser?.name?.split(' ') || [];
    const firstName = currentUser?.given_name || nameParts[0] || 'U';
    const lastName = currentUser?.family_name || nameParts[1] || 'S';
    const firstInitial = firstName && firstName.length > 0 ? firstName.charAt(0) : 'U';
    const lastInitial = lastName && lastName.length > 0 ? lastName.charAt(0) : 'S';
    return (firstInitial + lastInitial).toUpperCase();
  };

  const getFullName = () => {
    if (currentUser?.family_name && currentUser?.given_name) {
      return `${currentUser.family_name}, ${currentUser.given_name}`;
    }
    return currentUser?.name || currentUser?.email || 'User';
  };

  return (
    <div className="navbar-nav position-relative" ref={avatarRef} style={{ marginRight: '16px' }}>
      <Button variant="link" className="p-0" onClick={handleAvatarClick}>
        <div className="avatar-container">{getInitials()}</div>
      </Button>
      {showInfo && (
        <div className="user-info-popup">
          <div className="user-info-header">
            <div className="avatar-container-large">{getInitials()}</div>
            <div>
              <div className="user-name">{getFullName()}</div>
              <div className="user-email">{currentUser?.upn || currentUser?.email}</div>
            </div>
          </div>
          <div className="user-roles">{formatRoles(currentUser?.roles).join(', ')}</div>
          <Button variant="outline-danger" size="sm" className="w-100 mt-3" onClick={() => MsalTokenService.logout()}>
            <i className="fa fa-sign-out me-2" />
            Logout
          </Button>
        </div>
      )}
    </div>
  );
};

export default Avatar;
